// Calls the meet-token endpoint via the workspace SDK and returns
// { roomName, livekitToken, livekitUrl } that the caller passes to
// room.connect(...).
//
// Meet REQUIRES a real auth session (chat / calendar can run in dev-mode
// app_settings, but LiveKit needs a stable user identity for the token's
// `identity` claim). If no session exists this rejects loudly so the UI
// can show a "sign in to start a call" message instead of silently
// minting a guest token.
//
// Routes through workspaceProject.meet.token (rpc) so the workspace JWT
// + tenant scoping flows through the SDK's TokenManager rather than a
// raw Supabase access token.
import { getSDK } from '../../../shared/functions/sdk.js'

export const mintLivekitToken = async function (roomId) {
  const sdk = getSDK()
  // getSession() is async in v3.14 — without await session is a Promise
  // and access_token is undefined.
  const session = await sdk.getSession()
  if (!session?.access_token) throw new Error('meet requires a real session')

  try {
    return await sdk.execute('workspaceProject.meet.token', 'rpc', { roomId })
  } catch (err) {
    // SDK throws Error with the upstream HTTP status / message embedded —
    // surface a typed error so callers can switch on .status the same
    // way the raw fetch path did.
    const message = err?.message || ''
    let status = 0
    const m = message.match(/HTTP\s+(\d+)/iu) || message.match(/^(\d+)\s/u)
    if (m) status = parseInt(m[1], 10)
    const reason =
      message ||
      (status === 401 ? 'session expired — please sign in again'
        : status === 403 ? 'not allowed to join this room'
          : `status ${status || '?'}`)
    console.error('[mintLivekitToken]', status || '?', reason)
    const out = new Error(reason)
    out.status = status
    throw out
  }
}
